import EntryGrid from 'components/Inputs/EntryGrid';
import React, { useEffect } from 'react';
import { Row, Col, FormGroup } from 'reactstrap';
import TextBox from 'components/Inputs/TextBox';
import NumberInput from 'components/Inputs/NumberInput';
import { t } from 'i18next';

function CostInfoForm({ register, errors, control, watch, setValue, getValues }) {
  // Watch items array and other_service_charges
  const items = watch('items') || [];
  const otherServiceCharges = watch('costinfo.other_service_charges') || 0;

  // Calculate subtotal from items
  const calculateSubtotal = () => {
    return items.reduce((sum, item) => {
      const amount = parseFloat(item.amount) || 0;
      return sum + amount;
    }, 0);
  };

  // Calculate total amount (subtotal + other service charges)
  const calculateTotalAmount = () => {
    const subtotal = calculateSubtotal();
    const charges = parseFloat(otherServiceCharges) || 0;
    return subtotal + charges;
  };

  // Update total amount whenever items or other_service_charges change
  useEffect(() => {
    const totalAmount = calculateTotalAmount();
    setValue('costinfo.total_amount', totalAmount);
  }, [items, otherServiceCharges, setValue]);

  return (
    <EntryGrid title={t('Cost Information')}>
      <Row className='pt-1 pb-1'>
        <Col md={6} sm={12}>
          <FormGroup>
            <label>{t('Other Service Charges')}</label>
            <NumberInput
              className='form-control'
              errors={errors?.costinfo?.other_service_charges}
              defaultValue={0}
              value={watch('costinfo.other_service_charges')}
              onChange={(value) => {
                setValue('costinfo.other_service_charges', value);
              }}
            />
          </FormGroup>
        </Col>
        <Col md={6} sm={12}>
          <FormGroup>
            <label>{t('Total Amount')}</label>
            <TextBox
              className='form-control'
              type='number'
              step='0.01'
              value={calculateTotalAmount().toFixed(2)}
              disabled={true}
              style={{ backgroundColor: '#e9ecef', cursor: 'not-allowed' }}
            />
            <small className='text-muted'>
              Subtotal ({calculateSubtotal().toFixed(2)}) + Other Service Charges
            </small>
          </FormGroup>
        </Col>
      </Row>
    </EntryGrid>
  );
}

export default CostInfoForm;
